 import GraphemeSplitter from "grapheme-splitter";



// export function splitString(inputString) {
//     const splitter = new GraphemeSplitter();
//     const parts = splitter.splitGraphemes(inputString); // Properly splits multi-codepoint emojis
  
//     let result = "";
//     parts.forEach((part) => {
//       if (/[\p{Extended_Pictographic}]/u.test(part)) {
//         result += `<span class="emoji">${part}</span>`;
//       } else {
//         result += `<span class="text">${part}</span>`;
//       }
//     });
//     return result;
//   }


export function splitStringEmoji(inputString) {
  const splitter = new GraphemeSplitter();
  const parts = splitter.splitGraphemes(inputString); // Properly splits multi-codepoint emojis

  let result = "";
  parts.forEach((part) => {
    if (/[\p{Extended_Pictographic}]/u.test(part)) {
      result += `<span class="emoji">${part}</span>`;
    } else {
      result += `<span class="text">${part}</span>`;
   }
  });
  return result;
}



export function splitString(inputString) {
const emojiRegex = /(?:\p{Extended_Pictographic}\u200D?)+|\w+|\s+|[^\w\s]/gu;
const parts = inputString.match(emojiRegex) || [];

return parts.map(part => {
   if (/^\p{Extended_Pictographic}/u.test(part)) {  
      return splitStringEmoji(part);
     // alert(`<span class="emoji">${part}</span>` )
        // return `<span class="emoji">${part}</span>`;
   } else {
       return `<span class="text">${part}</span>`;
   }
}).join('');
}




  export function isFamilyEmoji(emoji) {
    // Define family emoji patterns (These Unicode sequences represent family emojis)
    const familyEmojis = ['👨‍👩‍👧', '👨‍👩‍👦'];

    // Check if the emoji matches any of the family emojis
    return familyEmojis.includes(emoji);
}

export function isFamilyEmojiFour(emoji) {
    // Define family emoji patterns (These Unicode sequences represent family emojis)
    // const familyEmojis = [
    //     "ðŸ‘¨â€ðŸ‘©â€ðŸ‘§â€ðŸ‘¦"
    // ];
    const familyEmojis = ['👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦', '👨‍👩‍👧‍👧'];

    // Check if the emoji matches any of the family emojis
    return familyEmojis.includes(emoji);
}

// Method used for split continuous letters without space typing
export function breakLongWord(word, maxWidth, pdf) {
  let brokenWords = [];
  let currentWord = "";

  for (let char of word) {
    if (pdf.getTextWidth(currentWord + char) > maxWidth) {
      brokenWords.push(currentWord);
      currentWord = char;
    } else {
      currentWord += char;
    }
  }

  if (currentWord) {
    brokenWords.push(currentWord);
  }

  return brokenWords;
};